import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCallMade = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11}
    height={11}
    fill="none"
    viewBox="0 0 11 11"
    {...props}
  >
    <path
      fill="currentColor"
      d="m8.825 2.563-7.52 7.916a.63.63 0 0 1-.496.219.7.7 0 0 1-.494-.24.75.75 0 0 1-.218-.53q0-.303.218-.532l7.5-7.896H4.314a.67.67 0 0 1-.508-.214A.74.74 0 0 1 3.6.754q0-.316.205-.535A.67.67 0 0 1 4.313 0h5.225q.301 0 .507.216a.75.75 0 0 1 .205.534v5.5q0 .319-.204.534A.67.67 0 0 1 9.542 7a.68.68 0 0 1-.51-.216.74.74 0 0 1-.207-.534z"
    />
  </svg>
);
export default SvgCallMade;
